import { Box, Grid, Typography } from '@mui/material';
import useStyles from '../../indexcss';

const Tagged = () => {
  const classes = useStyles();
  const menuItems = [
    { id: 1, text: 'Profile' },
    { id: 2, text: 'Login' },
    { id: 3, text: 'Issue' },
    { id: 4, text: 'Raise a Ticket' },
  ];

  const relatedArticles = [
    'How to change account password?',
    'How to close my account?',
    'Is it safe to open my account in the safari or any other browser?',
    'Can I open multiple accounts?',
    'Can I use my email id as a password also?',
  ];

  return (
    <div>
      <div className={classes.taggedHeader}>Tagged</div>
      <Grid container spacing={2}>
        {menuItems.map((item) => (
          <Grid key={item.id} item md={4} xs={12}>
            <Box className={classes.boxRounded}>{item.text}</Box>
          </Grid>
        ))}
      </Grid>

      <Box className={classes.boxmargintop}>
        <Typography className={classes.taggedHeader}>Related Articles</Typography>
        <ul className={classes.ulPadding}>
          {relatedArticles.map((article, index) => (
            <li key={index} className={classes.typoanswerprofile}>
              {article}
            </li>
          ))}
        </ul>
      </Box>
    </div>
  );
};

export default Tagged;
